export default __webpack_public_path__ + "static/perkama-logo-75d0bffe74817350198a1ac31472fafd.png";